/* eslint-disable import/prefer-default-export */
import { httpGet } from '../httpCalls';
import { getMainHubConfigs,getWhiteLabelProName,  updateMainHubs } from '../../actions/mainHubActions';
import { getSportRoomEntryPoint } from '../../actions/mainHubActions';
import { createSession, resetSession } from '../../actions/sessionActions';
import { resetError } from '../../actions/errorActions';

export const mapDispatchToProps = (dispatch) => ({
  resetForm: () => dispatch(resetError()),
  getMainHubConfigs: (mainHubId) => httpGet("mainHubs/"+mainHubId+"/mainHubConfigs/1").then((resp) => {
    dispatch(getMainHubConfigs(resp['data']));
    return Promise.resolve(resp['data']);
  }),
  getSportRoomEntryPoint: (mainHubId) => 
    httpGet("mainHubs/" + mainHubId + "/sportRoomEntryPoint").then((resp) => {
      dispatch(getSportRoomEntryPoint(resp['data']));
      return Promise.resolve(resp['data']);
  }),

  setMainHubSession: (id, reset = false) => {
    if (reset === true) {
      dispatch(resetSession());
    }
    dispatch(createSession({ mainHubId: parseInt(id, 10) }));
  },
  setConfigIdSession: (id) => {
    if (id !== undefined) {
      dispatch(createSession({ configId: parseInt(id, 10) }));
    }
  },
  getWhiteLabelProName: (mainHubId) => httpGet("mainHubs/"+mainHubId+"/getWhiteLabelProName").then((resp) => {
    if(mainHubId!==undefined){
      dispatch(getWhiteLabelProName(resp));
      return Promise.resolve(resp);
    } 
  }),
  setMainHubNameSession: (name) => {
    if (name !== undefined) {
      dispatch(createSession({ mainHubName: name }));
    }
  },
  setAppSession:(id)=>{
      dispatch(createSession({appId:parseInt(id,10)}));
  },
  setAreaSession: (id) => {
    if (id !== undefined) {
      dispatch(createSession({ areaId: parseInt(id, 10) }));
    }
  },
  removeSession: () => dispatch(resetSession()),
});
